const makeMemberBasicViewData = (services) => {
  const basicPermissionData = {};

  Object.keys(services).forEach((serviceId) => {
    const domain = JSON.parse(JSON.stringify(services[serviceId].domain));

    Object.keys(domain).forEach((domainId) => {
      Object.keys(domain[domainId]).forEach((actionId) => {
        domain[domainId][actionId] = {
          // ...domain[domainId][actionId],
          id: actionId,
          // ownerships: [],
          selected: false,
          // isException: false,
          isDefault: false,
          isFilter: false,
          isChange: false,
        };
      });
    });
    basicPermissionData[serviceId] = domain;
  });
  return basicPermissionData;
};

const setMemberView = (member, services, teams) => {
  const returnMember = JSON.parse(JSON.stringify(member));

  returnMember.viewData = makeMemberBasicViewData(services);
  Object.keys(returnMember.affiliatedTeams).forEach((teamId) => { // 멤버가 속한 팀
    const team = returnMember.affiliatedTeams[teamId];

    team.useRangeGroup = true;
    team.viewData = team.viewData || makeMemberBasicViewData(services);
    team.agreements = team.agreements || [];
    team.approval = team.approval || {
      admin: 'admin_authority',
      approve: null,
      comment: '',
    };

    if (!{}.hasOwnProperty.call(team, 'tags')) {
      const teamRangePermission = teams[team.id].viewData;
      const tags = {};
      const actions = {};
      const exceptions = {};


      Object.keys(teamRangePermission).forEach((serviceId) => {
        tags[serviceId] = teamRangePermission[serviceId].checkTag;
        actions[serviceId] = [];
        exceptions[serviceId] = [];
      });

      team.tags = tags;
      team.actions = actions;
      team.exceptions = exceptions;
    }

    team.exception.forEach((threeWord) => {
      const threeWordSplit = threeWord.split('-');
      const serviceId = threeWordSplit[0];
      const domainId = threeWordSplit[1];
      const actionId = threeWordSplit[2];
      const service = team.viewData[serviceId];
      const domainSplit = domainId.split(':');

      if (domainSplit[0] === 'tag') {
        const range = teams[teamId].viewData[serviceId].tags[domainSplit[1]];

        if (!team.actions[serviceId].includes(actionId)) {
          team.actions[serviceId].push(actionId);
        }
        range.forEach((domainSplitId) => {
          returnMember.viewData[serviceId][domainSplitId][actionId].selected = true;
          returnMember.viewData[serviceId][domainSplitId][actionId].isDefault = true;
          returnMember.viewData[serviceId][domainSplitId][actionId].isFilter = true;
          service[domainSplitId][actionId].selected = true;
          service[domainSplitId][actionId].isFilter = true;
          service[domainSplitId][actionId].isDefault = true;
        });
      } else {
        returnMember.viewData[serviceId][domainId][actionId].selected = true;
        returnMember.viewData[serviceId][domainId][actionId].isDefault = true;
        service[domainId][actionId].selected = true;
        service[domainId][actionId].isDefault = true;
      }
      if (!team.exceptions[serviceId].includes(threeWord)) {
        team.exceptions[serviceId].push(threeWord);
      }
    });
  });
  return returnMember;
};

export default {
  setMemberView,
  makeMemberBasicViewData,
};



// WEBPACK FOOTER //
// ./src/filters/getMemberViewData.js